import { Box, Stack, styled, Typography } from '@mui/material';
import { CitToken, H1, Section, useBreakpoints } from 'shared';

import { Beam } from '../assets/Beam';

const tokenWidthPx = 185;
const tokenInsetRatio = 40 / tokenWidthPx;

const BeamItem = styled(Box)({
  position: 'absolute',
  top: 0,
  width: 'var(--citRaysSlotW)',
  height: '230px',
  overflow: 'hidden',
  pointerEvents: 'none',
});

export const TokenCitHero = () => {
  const { isDownMdLayout } = useBreakpoints();

  return (
    <Section sx={{ mb: { xs: 5, md: 6 } }}>
      <H1
        text="CRAT Impact Token (CIT)"
        textAlign="center"
        lineHeight="1.25"
        fontSize={{ xs: 32, sm: 52, md: 72 }}
        highlightedWords={[0, 1]}
      />
      <Typography
        variant="h4"
        textAlign="center"
        lineHeight="1.45"
        className="regular"
        sx={{ mt: { xs: 2, md: 3 }, fontSize: { xs: 18, md: 24 } }}
      >
        The Gamified Engagement Layer <br /> of the CratD2C Ecosystem
      </Typography>

      <Stack alignItems="center" spacing={{ xs: 4, md: 5 }} sx={{ mt: { xs: 2, md: 4 } }}>
        {isDownMdLayout ? (
          <Box
            component="img"
            src={CitToken}
            alt="CIT token"
            sx={{
              width: 165,
              height: 'auto',
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '230px',
              position: 'relative',
              overflow: 'hidden',
              userSelect: 'none',
              '--citTokenW': `${tokenWidthPx}px`,
              '--citTokenInsetRatio': `${tokenInsetRatio}`,
              '--citRaysSlotW':
                'max(0px, calc(50% - (var(--citTokenW) / 2) + calc(var(--citTokenW) * var(--citTokenInsetRatio))))',
            }}
          >
            <BeamItem
              aria-hidden="true"
              sx={{
                left: 0,
              }}
            >
              <Beam
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  transform: 'rotate(180deg)',
                }}
              />
            </BeamItem>

            <BeamItem
              aria-hidden="true"
              sx={{
                right: 0,
              }}
            >
              <Beam
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                }}
              />
            </BeamItem>
            <Box
              component="img"
              src={CitToken}
              alt="CIT token"
              sx={{
                position: 'absolute',
                width: 'var(--citTokenW)',
                height: '170px',
                left: '50%',
                top: 28,
                scale: 1.01,
                transform: 'translateX(-50%)',
                objectFit: 'contain',
              }}
            />
          </Box>
        )}
      </Stack>
    </Section>
  );
};
